import React from "react";
import { useNavigate } from "react-router-dom";
import { BankOutlined, PhoneOutlined, PoweroffOutlined, UserOutlined } from "@ant-design/icons";
import StringUtils from "../../../util/StringUtils";
import SessionService from "../../../services/session/SessionService";
import { UserInfoHeader, Avatar, UserInformationWrapper, Name, Operation, PhoneNumber, ProfileDetails, TenantName } from "./UserManagement.styled";
interface UserManagementProps {}


const UserManagement: React.FC<UserManagementProps> = (props) => {
    const navigate = useNavigate();

    const profile = SessionService.getInstance().getCurrentUserProfile();           
    
    let onSignOut = ()=> {
        SessionService.getInstance().setAuthorization('');
        window.location.href = '/';
    };

    return (
         <UserInformationWrapper>
            <UserInfoHeader>
                <Avatar />
                <ProfileDetails>
                    <TenantName><BankOutlined /> {profile.tenantName} </TenantName>
                    <Name><UserOutlined /> {profile.name} </Name>
                    <PhoneNumber><PhoneOutlined /> {StringUtils.emptyToDefault(profile.phoneNumber, "未填写手机号")} </PhoneNumber>
                </ProfileDetails>
            </UserInfoHeader>
            <Operation onClick={onSignOut}>
                <PoweroffOutlined style={{ 
                    fontSize: '18px', 
                    color: '#555555', 
                    paddingRight: '12px' }}
                />
                退出当前登录
            </Operation>
        </UserInformationWrapper>
    );
};

export default UserManagement;